import Vue from 'vue';
import firebase from 'firebase/app';
import VueRouter from 'vue-router';
import VueBodyClass from 'vue-body-class';

import Account from './../views/Account';
import AccountDisabled from './../views/AccountDisabled';
import Categories from './../views/Categories';
import Category from './../views/Category';
import Dashboard from './../views/Dashboard';
import EditBoard from './../views/EditBoard';
import ManageLogin from './../views/ManageLogin';
import ForgottenPassword from './../views/ForgottenPassword';
import Home from './../views/Home';
import ListBoards from './../views/ListBoards';
import Login from './../views/Login';
import NewBoard from './../views/NewBoard';
import PageNotFound from './../views/PageNotFound';
import Play from './../views/Play';
import PlayNavigation from './../views/PlayNavigation';
import Profile from './../views/Profile';
import Register from './../views/Register';
import store from './../store';
import ViewBoard from './../views/ViewBoard';
import ViewTile from './../views/ViewTile';
import Welcome from './../views/Welcome';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      bodyClass: 'home',
    },
  },
  {
    path: '/index',
    name: 'home',
    component: Home,
    meta: {
      bodyClass: 'home',
    },
  },
  {
    path: '/index.html',
    name: 'home',
    component: Home,
    meta: {
      bodyClass: 'home',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      bodyClass: 'dashboard',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/account-disabled',
    name: 'account-disabled',
    component: AccountDisabled,
    meta: {
      bodyClass: 'account-disabled',
      requiresGuest: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/play',
    name: 'play-navigation',
    component: PlayNavigation,
    meta: {
      bodyClass: 'play-navigation',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/board',
    name: 'board',
    component: ListBoards,
    meta: {
      bodyClass: 'board',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/boards',
    name: 'boards',
    component: ListBoards,
    meta: {
      bodyClass: 'boards',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/categories',
    name: 'categories',
    component: Categories,
    meta: {
      bodyClass: 'categories',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      bodyClass: 'profile',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
    meta: {
      bodyClass: 'welcome',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      bodyClass: 'account',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/manage-login',
    name: 'manage-login',
    component: ManageLogin,
    meta: {
      bodyClass: 'manage-login',
      requiresGuest: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      bodyClass: 'login',
      requiresGuest: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      bodyClass: 'register',
      requiresGuest: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/forgotten-password',
    name: 'forgotten-password',
    component: ForgottenPassword,
    meta: {
      bodyClass: 'forgotten-password',
      requiresGuest: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/new-board',
    name: 'new-board',
    component: NewBoard,
    meta: {
      bodyClass: 'new-board',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/edit-board/:boardId',
    name: 'edit-board',
    component: EditBoard,
    meta: {
      bodyClass: 'edit-board',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/board/:boardId',
    name: 'view-board',
    component: ViewBoard,
    children: [],
    meta: {
      bodyClass: 'view-board',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/play/:boardIdOrSlug',
    name: 'play',
    component: Play,
    children: [],
    meta: {
      bodyClass: 'play',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/category/:categorySlug',
    name: 'category',
    component: Category,
    children: [],
    meta: {
      bodyClass: 'category',
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '*',
    component: PageNotFound,
    meta: {
      bodyClass: 'page-not-found',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

const vueBodyClass = new VueBodyClass(routes);

router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next);

  const userCanViewAdminStuff = store.getters['userVuexModule/userCanViewAdminStuff'];
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest);
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const userHasAccountAndVerifiedEmail = firebase.auth().currentUser && firebase.auth().currentUser.emailVerified ? true : false;
  const accountIsEnabled = store.getters['userVuexModule/getEnabled'];
  const userHasGamertag = store.getters['userVuexModule/getGamerTag'] ? true : false;

  if (to.name !== 'category' || to.name !== 'play') {
    store.dispatch('SET_CURRENT_CATEGORY_ACTION', {currentCategory: ''});
  }

  if (requiresAuth) {
    if (!userHasAccountAndVerifiedEmail) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      if (!userHasGamertag) {
        next({
          path: '/welcome',
        });
      } else {
        if (requiresAdmin) {
          if (!userCanViewAdminStuff) {
            next({
              path: '/',
            });
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  } else if (requiresGuest) {
    if (userHasAccountAndVerifiedEmail) {
      if (to.query.redirect && to.query.redirect !== '') {
        next({
          path: to.query.redirect,
        });
      } else {
        next({
          path: '/dashboard',
        });
      }
    } else {
      next();
    }
  } else {
    if (to.name === 'home') {
      next({
        path: '/',
      });
    } else {
      if (from.query.redirect !== '') {
        next({
          path: from.query.redirect,
        });
      } else {
        next();
      }
    }
  }
});

export default router;
